import {
    Container,
    Typography,
    Box,
    Stack,
} from "@mui/material";
import React from 'react';
import { useTranslation, Translation } from "react-i18next";
import { getLang } from "../../helper/LangHelper";
import RedemptionQRCard from "../../components/redemption/RedemptionQRCard";

export default function TestRedemptionQRCard() {
    const { t } = useTranslation();

    let lang = getLang();

    const handleQRCodeUpdated = (qrCode) => { 
        console.debug("handleQRCodeUpdated called: ", qrCode);
    }

    return (
        <Container maxWidth="lg">
            <Stack direction="column">
                <Typography variant="h3">TestRedemptionQRCard</Typography>


                <Box>
                    <p>Current Lang: {lang}</p>
                    <p>translateText: {t("testing.msg")}</p>
                </Box>
                <RedemptionQRCard onQRCodeUpdated={handleQRCodeUpdated}/>
            </Stack>
        </Container>
    )
}
